/* Component Dependencies */
var contentClusterHighlightsTemplate = require('templates/contentClusterHighlights.hbs');
var AriesComponent = require('libs/aries-component');
var FadeInHandler = require('libs/fade-in-handler');
var carouselWidthHandler = require('libs/multiCarousel-width-handler');

AriesComponent.create({
	type: 'contentClusterHighlights',
	template: {
		'contentClusterHighlights': contentClusterHighlightsTemplate
	},
	bindEvents: function () {
		var _self = this,
				triggerElement = '.tile-content-cluster-highlights .fade-wrap',
				options = $(triggerElement).data(),
				mediaDesktop = window.matchMedia("(min-width: 769px)"),
				$carousel;
		_self.parentSelector = $('[data-component-id="' + _self.componentId + '"]'),
		$carousel = _self.parentSelector.find('.mi-carousel');
		FadeInHandler.init(triggerElement, options);
		$carousel.on('init', function(event, slick) {
			_self.$el.find('.mi-carousel .l-picture-wrapper img').first().on('load',function () {
				setTimeout(function() {
					carouselWidthHandler.calculateWidth.call(_self);
				},0);
			});
			if (mediaDesktop.matches) {
				setTimeout(function() {
				$carousel.find('[aria-describedby]').removeAttr('aria-describedby');
				})
			}
		});
	}
});
